import imgEmty from '@img/empty.svg'
import { Empty, Flex } from '@ui/index'


/** Страница не найдена */
export const Page404 = () => {
    return <>
        <Flex alignItems='center' justifyContent='center' flexGrow={1} height='100%'>
            <Empty image={imgEmty} />
        </Flex>
    </>
}